import { useI18nContext } from "@hopper-b2b/i18n";
import styles from "./styles.module.scss";

const UltravioletaBadge = () => {
  const { t } = useI18nContext();
  return <div className={styles.ultravioletaBadge}>{t("ultravioleta")}</div>;
};

export default UltravioletaBadge;
